import { Router } from '@angular/router';
import { AccountStoreService } from '../../storage/account-store.service';
import { AuthService } from './auth.service';
import { AuthApiAccountService } from './auth-api-account.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RedirectService {

  constructor(private router: Router,
              private accountStoreService: AccountStoreService,
              private authApiAccountService: AuthApiAccountService,
              private authService: AuthService) {
  }

  redirectToDefault() {
    const accId = this.accountStoreService.getAccountId();

    if (accId) {
      this.authApiAccountService.readProjectById$(accId).subscribe(project => {
        if (project) {
          this.authService.checkMRARightsForAccountId$(accId).subscribe(mraRights => {
            if (mraRights && mraRights.rights) {
              this.router.navigate(['/project/' + project.id]);
            } else {
              this.redirectToProjectSelection();
            }
          }, err => {
            this.redirectToProjectSelection();
          });
        } else {
          this.redirectToProjectSelection();
        }
      }, err => {
        this.redirectToProjectSelection();
      });
    } else {
      this.redirectToProjectSelection();
    }
  }

  private redirectToProjectSelection() {
    this.router.navigate(['/accounts']);
  }

  redirectToAccount(accountId: string) {
    this.router.navigate(['/project/' + accountId]);
  }
}
